import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { Dialog } from '../Dialog';
import { useUIState } from '../../state/contexts/UIStateContext';

export function ValidationErrorModal() {
  const { setModal, modalData } = useUIState();
  return (
    <Dialog title="⚠ Validation Error" titleStyle={{ color: C.danger }} onClose={() => setModal(null)}>
        <div style={{ fontSize: 13, marginBottom: 16 }}>{modalData.message}</div>
        {modalData.missing && modalData.missing.length > 0 && modalData.missing[0] !== 'certifications' && modalData.missing[0] !== 'agreement' && modalData.missing[0] !== 'authorizerEmail' && (
          <div style={{ background: C.dangerLight, borderRadius: 8, padding: 12, marginBottom: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: C.danger, marginBottom: 8 }}>Missing Fields:</div>
            {modalData.missing.map((f: string, i: number) => <div key={i} style={{ fontSize: 12, color: C.danger }}>• {f.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase())}</div>)}
          </div>
        )}
        <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => setModal(null)}>OK</button>
    </Dialog>
  );
}
